module.exports = __webpack_public_path__ + "static/check4-853ea9f50c1e43592d526a404d85f132.png";